import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    data:{
        lplayout:{},
        templateNo :'',
        emaillayout:{},
        fields:[],
        name:''
    },
    
}

export const createLPSlice = createSlice({
    name: 'createLp',
    initialState,
    reducers: {
        setLPDetails: {
            reducer(state, action) {
                state.data = {...state.data,...action.payload};
            }
        },
        unSet: {
            reducer(state) {
                state.data =  initialState.data ;
            }
        }
    }

})

export const { setLPDetails, unSet } = createLPSlice.actions;

export default createLPSlice.reducer;